import React, { Component } from 'react'
import Cookies from 'js-cookie'

class AuthenticatedDropdownInstitutional extends Component {
  constructor(props) {
    super(props)
    this.yourReportsStyle = `UtilityNavigation-action u-textPrimary no-lock-icon UtilityNavigation-pipe ${
      props.mobile ? 'Button Button--secondary' : ''
    }`
    this.state = {
      isLoggedIn: null,
    }
  }

  componentDidMount() {
    const isLoggedIn = Cookies.get('CM_USER_STATUS_INST')

    this.setState({
      isLoggedIn: isLoggedIn,
    })
  }

  logOff = () => {
    this.setState({
      isLoggedIn: null,
    })
  }

  render() {
    return this.state.isLoggedIn === 'LOGGEDIN' ? (
      <>
        <li className="UtilityNavigation-listItem u-inlineBlock u-marginRight1gu u-textSizeMsr u-marginLeft3gu u-sm-marginLeft0">
          <a
            className={this.yourReportsStyle}
            href="/web/columbia/secure/institutional/your-reports"
          >
            Your Reports
          </a>
        </li>
        <li className="UtilityNavigation-listItem u-hidden u-sm-inlineBlock u-marginLeft1gu u-marginTop2gu">
          <a
            className="UtilityNavigation-action u-textNoWrap Button Button--secondary no-lock-icon"
            href="/web/columbia/secure/institutional/logout"
            onClick={this.logOff}
          >
            Log Out
          </a>
        </li>
      </>
    ) : (
      <li className="UtilityNavigation-listItem u-hidden u-sm-inlineBlock u-marginLeft1gu u-marginLeft3gu u-sm-marginLeft0">
        <a
          className="UtilityNavigation-action u-textNoWrap Button Button--secondary"
          href="/web/columbia/institutional/login"
        >
          Log In
        </a>
      </li>
    )
  }
}

export default AuthenticatedDropdownInstitutional
